import { ChevronDown } from "lucide-react";
import { useEffect, useState } from "react";

import { Input } from "@/components/ui/input";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@/components/ui/popover";

import ToolbarButton from "./toolbar-button";

type Direction = "top" | "right" | "bottom" | "left";

const directions: Array<{ key: Direction; label: string }> = [
  { key: "top", label: "بالا" },
  { key: "right", label: "راست" },
  { key: "bottom", label: "پایین" },
  { key: "left", label: "چپ" }
];

const parsePixels = (value: string, fallback: number) => {
  const parsedValue = Number.parseInt(value, 10);
  return Number.isNaN(parsedValue) ? fallback : parsedValue;
};

const PageMargin: React.FC<
  React.ComponentProps<"button"> & {
    editorRef: React.RefObject<HTMLDivElement>;
  }
> = ({ editorRef }) => {
  const [margin, setMargin] = useState<Record<Direction, number>>({
    top: 8,
    right: 8,
    left: 8,
    bottom: 8
  });

  useEffect(() => {
    if (editorRef.current) {
      const computedStyle = getComputedStyle(editorRef.current);

      setMargin({
        top: parsePixels(computedStyle.paddingTop, 8),
        right: parsePixels(computedStyle.paddingRight, 8),
        left: parsePixels(computedStyle.paddingLeft, 8),
        bottom: parsePixels(computedStyle.paddingBottom, 8)
      });
    }
  }, []);

  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.style.paddingTop = `${margin.top}px`;
      editorRef.current.style.paddingRight = `${margin.right}px`;
      editorRef.current.style.paddingLeft = `${margin.left}px`;
      editorRef.current.style.paddingBottom = `${margin.bottom}px`;
    }
  }, [margin]);

  const updateMargin = (direction: Direction, value: string) => {
    const nextValue = Math.min(
      100,
      Math.max(0, Number.parseInt(value, 10) || 0)
    );

    setMargin((prev) => ({ ...prev, [direction]: nextValue }));
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <ToolbarButton className="flex w-fit items-center gap-x-1">
          <svg
            width="18"
            height="26"
            viewBox="0 0 18 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="16.3333"
              height="25"
              fill="white"
              stroke="#273646"
            />
            <line
              x1="3.96875"
              y1="0.866699"
              x2="3.96875"
              y2="25.1334"
              stroke="#93C8F5"
            />
            <line
              x1="13.5"
              y1="0.866699"
              x2="13.5"
              y2="25.1334"
              stroke="#93C8F5"
            />
            <line
              x1="0.867188"
              y1="3.8335"
              x2="16.4672"
              y2="3.8335"
              stroke="#93C8F5"
            />
            <line
              x1="0.867188"
              y1="22.0332"
              x2="16.4672"
              y2="22.0332"
              stroke="#93C8F5"
            />
          </svg>
          Margins
          <ChevronDown />
        </ToolbarButton>
      </PopoverTrigger>
      <PopoverContent className="w-[270px] space-y-1 p-2">
        {directions.map((direction) => (
          <div
            key={direction.key}
            title={`مارجین ${direction.label}`}
            className="hover:bg-muted/60 grid grid-cols-[48px_62px_1fr] items-center gap-1 rounded-sm px-1 py-1"
          >
            <span className="text-muted-foreground text-[11px]">
              {direction.label}
            </span>
            <Input
              type="number"
              className="h-7 px-2 text-xs"
              min={0}
              max={100}
              step={1}
              value={margin[direction.key]}
              onChange={(e) => updateMargin(direction.key, e.target.value)}
            />
            <Input
              type="number"
              step="1"
              className="h-4 border-none p-0"
              min={0}
              max={100}            value={margin[direction.key]}
              onChange={(e) => updateMargin(direction.key, e.target.value)}
            />
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};
export default PageMargin;

